class UsageShowcaseSlider {
  constructor(container) {
    if (!container) {
      return;
    }

    this.container = container;
    this.swiper = null;
    this.globalListeners = [];
    this.currentSlideIndex = 1;
    this.filterButtons = [];

    try {
      this.init();
    } catch (error) {}
  }

  init() {
    this.initFilterButtons();
    this.initSwiper();
    this.bindEvents();
  }

  initFilterButtons() {
    this.filterButtons = Array.from(
      this.container.querySelectorAll(".usage-showcase__filter-btn")
    );

    if (this.filterButtons.length === 0) {
      this.filterButtons = Array.from(
        this.container.querySelectorAll("button")
      );
      if (this.filterButtons.length === 0) {
        return;
      }
    }

    this.setActiveButton(this.currentSlideIndex);
    this.filterButtons.forEach((button, index) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        this.goToSlide(index);
      });
    });
  }

  initSwiper() {
    const swiperElement = this.container.querySelector(
      ".usage-showcase__swiper"
    );

    if (!swiperElement) {
      return;
    }

    const totalSlides = swiperElement.querySelectorAll(".swiper-slide").length;
    const swiperWrapper = swiperElement.querySelector(".swiper-wrapper");

    this.swiper = new Swiper(swiperElement, {
      slidesPerView: "auto",
      spaceBetween: 12,
      loop: false,
      grabCursor: true,
      allowTouchMove: true,
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 6,
          centeredSlides: false,
        },
        768: {
          slidesPerView: "auto",
          spaceBetween: 12,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: "auto",
          spaceBetween: 12,
          centeredSlides: true,
          initialSlide: 1,
        },
      },
      navigation: false,
      pagination: false,
      a11y: {
        enabled: true,
        prevSlideMessage: "Usage précédent",
        nextSlideMessage: "Usage suivant",
        firstSlideMessage: "Premier usage",
        lastSlideMessage: "Dernier usage",
      },
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      on: {
        init: () => {
          setTimeout(() => {
            this.goToSlide(this.currentSlideIndex);
          }, 100);
        },
        slideChange: () => {
          if (!this.swiper) {
            return;
          }
          const activeIndex = this.swiper.activeIndex;
          this.setActiveButton(activeIndex);
          this.currentSlideIndex = activeIndex;
        },
        slideChangeTransitionEnd: () => {},
      },
    });
  }

  goToSlide(index) {
    if (!this.swiper) {
      return;
    }

    if (index < 0 || index >= this.filterButtons.length) {
      return;
    }

    this.setActiveButton(index);
    this.swiper.slideTo(index, 500);
    this.currentSlideIndex = index;
  }

  setActiveButton(activeIndex) {
    this.filterButtons.forEach((button, index) => {
      if (index === activeIndex) {
        button.classList.add("usage-showcase__filter-btn--active");
        button.setAttribute("aria-pressed", "true");
      } else {
        button.classList.remove("usage-showcase__filter-btn--active");
        button.setAttribute("aria-pressed", "false");
      }
    });
  }

  bindEvents() {
    const resizeHandler = () => {
      if (this.swiper) {
        this.swiper.update();
        setTimeout(() => {
          this.goToSlide(this.currentSlideIndex);
        }, 100);
      }
    };

    window.addEventListener("resize", resizeHandler);
    this.globalListeners.push({
      element: window,
      event: "resize",
      handler: resizeHandler,
    });
    const sectionLoadHandler = (event) => {
      if (
        event.target === this.container ||
        event.target.contains(this.container)
      ) {
        this.destroy();
        setTimeout(() => this.init(), 100);
      }
    };

    document.addEventListener("shopify:section:load", sectionLoadHandler);
    this.globalListeners.push({
      element: document,
      event: "shopify:section:load",
      handler: sectionLoadHandler,
    });
    const blockSelectHandler = (event) => {
      if (event.target.closest(".usage-showcase")) {
        let slide, slideIndex;
        slide = event.target.closest(".swiper-slide");
        if (slide && this.swiper) {
          slideIndex = Array.from(slide.parentNode.children).indexOf(slide);
          this.goToSlide(slideIndex);
        }
      }
    };

    document.addEventListener("shopify:block:select", blockSelectHandler);
    this.globalListeners.push({
      element: document,
      event: "shopify:block:select",
      handler: blockSelectHandler,
    });
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    this.globalListeners.forEach(({ element, event, handler, options }) => {
      element.removeEventListener(event, handler, options);
    });
    this.globalListeners = [];
    this.currentSlideIndex = 1;
    this.filterButtons = [];
  }
}

function initializeUsageShowcaseSliders() {
  if (typeof Swiper === "undefined") {
    setTimeout(initializeUsageShowcaseSliders, 200);
    return;
  }

  const sectionContainers = document.querySelectorAll(".usage-showcase");

  if (sectionContainers.length === 0) {
    return;
  }

  sectionContainers.forEach((container) => {
    try {
      const slider = new UsageShowcaseSlider(container);
      container.usageShowcaseSlider = slider;
    } catch (error) {
    }
  });
}
let initAttempts = 0;
const maxAttempts = 10;

function attemptInitialization() {
  initAttempts++;
  if (typeof Swiper === "undefined") {
    if (initAttempts < maxAttempts) {
      setTimeout(attemptInitialization, 300);
    }
    return;
  }

  const sections = document.querySelectorAll(".usage-showcase");
  if (sections.length === 0) {
    if (initAttempts < maxAttempts) {
      setTimeout(attemptInitialization, 300);
    }
    return;
  }

  initializeUsageShowcaseSliders();
}

document.addEventListener("DOMContentLoaded", function () {
  attemptInitialization();
});
window.addEventListener("load", function () {
  if (initAttempts === 0) {
    attemptInitialization();
  }
});
document.addEventListener("shopify:section:load", function (event) {
  const container = event.target.querySelector(".usage-showcase");
  if (container) {
    new UsageShowcaseSlider(container);
  }
});

document.addEventListener("shopify:section:unload", function (event) {
  const container = event.target.querySelector(".usage-showcase");
  if (container && container.usageShowcaseSlider) {
    container.usageShowcaseSlider.destroy();
  }
});
